import type { HTMLAttributes, ReactNode } from 'react';

import { Label } from './label';

import { cn } from '@/lib/cn';

/**
 * Wrapper minimalista para campos de formulário com label + erro abaixo.
 * Não usa o componente Form do shadcn (que depende de Radix Slot) — para
 * esta sprint, react-hook-form `register()` direto basta.
 */

interface FormFieldProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  htmlFor: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: ReactNode;
}

export function FormField({
  label,
  htmlFor,
  error,
  hint,
  required,
  children,
  className,
  ...rest
}: FormFieldProps) {
  return (
    <div className={cn('space-y-2', className)} {...rest}>
      <Label htmlFor={htmlFor}>
        {label}
        {required ? <span className="ml-0.5 text-destructive">*</span> : null}
      </Label>
      {children}
      {hint && !error ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
      {error ? (
        <p role="alert" className="text-sm font-medium text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
}
